import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { idTicketHistorial, crearTicketregistro, getResolucion, newRegistromto } from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import styles from "./TicketDetailModal.module.css";
import { FaTicketAlt, FaClock, FaCheckCircle, FaTimesCircle, FaTools } from 'react-icons/fa';

const MySwal = withReactContent(Swal);

function TicketModal({ show, onHide, ticketId, flag, registros: propRegistros }) {
    const dispatch = useDispatch();
    const historial = useSelector((state) => state.tickhistorial);
    const usuario = useSelector((state) => state.usuario);
    const navigate = useNavigate();
    const [newStatus, setNewStatus] = useState("");
    const [observacion, setObservacion] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (ticketId && (!propRegistros || propRegistros.length === 0)) {
            dispatch(idTicketHistorial(ticketId));
        }
    }, [dispatch, ticketId, propRegistros]);

    const formatFecha = (fecha) => {
        return format(new Date(fecha), "dd/MM/yyyy HH:mm:ss");
    };

    const handleStatusChange = (e) => {
        setNewStatus(e.target.value);
    };

    const handleObservacionChange = (e) => {
        setObservacion(e.target.value);
    };

    const sourceRegistros = propRegistros && propRegistros.length > 0
        ? propRegistros
        : (historial?.registros || []);

    const filteredRegistros = sourceRegistros.filter(reg => {
        const cardFlag = (flag === undefined || flag === null) ? null : String(flag);
        const recordFlag = (reg.flag === undefined || reg.flag === null) ? null : String(reg.flag);
        return cardFlag === recordFlag;
    });

    const displayRegistros = filteredRegistros.length > 0 ? filteredRegistros : sourceRegistros;

    const handleUpdateStatus = async (registroId) => {
        if (newStatus && observacion) {
            const fechaActual = new Date();
            const formattedFecha = format(fechaActual, "yyyy-MM-dd HH:mm:ss");

            const isMto = flag !== undefined && flag !== null && String(flag) === "2";

            const data = {
                fecha: formattedFecha,
                Observacion: observacion,
                TicketId: displayRegistros[0].TicketId,
                EstadoId: newStatus === "Cancelado" ? 6 : null,
                nombreUsuario: usuario.usuario.nombre,
                correoUsuario: usuario.usuario.email,
                ...(isMto && { flag: 2 }),
            };

            setLoading(true);

            try {
                if (isMto) {
                    await dispatch(newRegistromto(data));
                } else {
                    await dispatch(crearTicketregistro(data));
                }

                MySwal.fire({
                    title: 'Actualización Exitosa',
                    text: 'El ticket ha sido actualizado exitosamente.',
                    icon: 'success',
                    confirmButtonText: 'Aceptar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate("/seguimiento-ticket");
                        window.location.reload();
                    }
                });
                setNewStatus("");
                setObservacion("");
                onHide();
            } catch (error) {
                setLoading(false);
                MySwal.fire({
                    title: 'Error',
                    text: 'Hubo un error al actualizar el ticket.',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            }
        } else {
            alert("La observación es obligatoria.");
        }
    };

    const handleCloseTicket = async () => {
        if (ticketId) {
            try {
                const resolucionData = await dispatch(getResolucion(ticketId));
                const targetRoute = (flag !== undefined && flag !== null && String(flag) === "2")
                    ? "/cerrartickmto"
                    : "/cerrartick";

                navigate(targetRoute, {
                    state: {
                        ticketId,
                        resolucionDetails: resolucionData,
                    },
                });
                onHide();
            } catch (error) {
                MySwal.fire({
                    title: 'Error',
                    text: 'Error al obtener detalles de resolución.',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
            }
        }
    };

    if (!show || displayRegistros.length === 0) {
        return null;
    }

    const allCreado = displayRegistros.every(
        (registro) => registro.estadoDescripcion === "Creado"
    );

    return (
        <Modal show={show} onHide={onHide} centered size="lg" className={styles.customModal}>
            <Modal.Header closeButton className={styles.modalHeader}>
                <Modal.Title className={styles.modalTitle}>
                    <FaTicketAlt style={{ marginRight: '12px', color: '#3b82f6' }} />
                    Ticket #{displayRegistros[0].TicketId}
                    <span className={styles.areaBadge}>
                        {flag !== undefined && flag !== null && String(flag) === "2" ? "Área Mto." : "Gest. TI"}
                    </span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.modalBody}>
                <div className={styles.timeline}>
                    {displayRegistros.map((registro, index) => (
                        <div key={registro.id} className={styles.timelineItem}>
                            <div className={styles.timelineIcon}>
                                {registro.estadoDescripcion === "Resuelto" ? <FaCheckCircle color="#10b981" /> :
                                    registro.estadoDescripcion === "En Proceso" ? <FaTools color="#f59e0b" /> :
                                        <FaClock color="#3b82f6" />}
                            </div>
                            <div className={styles.timelineContent}>
                                <div className={styles.timelineHeader}>
                                    <span className={`${styles.statusBadge} ${styles[registro.estadoDescripcion.replace(/\s+/g, '').toLowerCase()]}`}>
                                        {registro.estadoDescripcion}
                                    </span>
                                    <span className={styles.timelineDate}>
                                        <FaClock size={12} style={{ marginRight: '4px' }} />
                                        {formatFecha(registro.fecha)}
                                    </span>
                                </div>
                                <p className={styles.timelineObservacion}>{registro.observacion}</p>
                                {registro.estadoDescripcion === "Resuelto" && (
                                    <Button
                                        className={styles.closeTicketBtn}
                                        size="sm"
                                        onClick={handleCloseTicket}
                                    >
                                        <FaCheckCircle style={{ marginRight: '6px' }} /> Finalizar y Cerrar Ticket
                                    </Button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                {allCreado && (
                    <div className={styles.actionSection}>
                        <h5 className={styles.actionTitle}><FaTimesCircle style={{ marginRight: '8px' }} /> Gestión de Cancelación</h5>
                        <div className={styles.updateCard}>
                            <Form.Group controlId="statusSelect" className="mb-3">
                                <Form.Label className={styles.inputLabel}>¿Desea cancelar este ticket?</Form.Label>
                                <Form.Control
                                    as="select"
                                    className={styles.selectInput}
                                    value={newStatus}
                                    onChange={handleStatusChange}
                                >
                                    <option value="" disabled>Seleccione una opción</option>
                                    <option value="Cancelado">Sí, solicitar cancelación</option>
                                </Form.Control>
                            </Form.Group>

                            {newStatus === "Cancelado" && (
                                <div className={styles.cancelDetails}>
                                    <Form.Group controlId="observacionInput" className="mb-3">
                                        <Form.Label className={styles.inputLabel}>Motivo de la cancelación</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            className={styles.textArea}
                                            value={observacion}
                                            onChange={handleObservacionChange}
                                            placeholder="Por favor explique por qué desea cancelar el ticket..."
                                        />
                                    </Form.Group>
                                    <Button
                                        className={styles.submitUpdateBtn}
                                        onClick={() => handleUpdateStatus(displayRegistros[0].id)}
                                        disabled={loading}
                                    >
                                        {loading ? 'Procesando...' : 'Confirmar Cancelación'}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className={styles.modalFooter}>
                <Button className={styles.closeBtn} onClick={onHide}>
                    Entendido
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default TicketModal;
